import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Ideas by Status',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Ideas by Status',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Ideas',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Intake',
                                  y: {
                                    '#': {
                                      '@': 'intake',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Score & Prioritize',
                                  y: {
                                    '#': {
                                      '@': 'prioritize',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Charter',
                                  y: {
                                    '#': {
                                      '@': 'charter',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Build',
                                  y: {
                                    '#': {
                                      '@': 'build',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Package & Release',
                                  y: {
                                    '#': {
                                      '@': 'release',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    build: {
      filter: {
        '=': [
          {
            '@.': '!status',
          },
          'Build',
        ],
      },
      target: 'ent:!innovation_ideas:!innovation_idea',
      selection: {
        '@.': '!id',
      },
    },
    intake: {
      filter: {
        '=': [
          {
            '@.': '!status',
          },
          'Intake',
        ],
      },
      target: 'ent:!innovation_ideas:!innovation_idea',
      selection: {
        '@.': '!id',
      },
    },
    charter: {
      filter: {
        '=': [
          {
            '@.': '!status',
          },
          'Charter',
        ],
      },
      target: 'ent:!innovation_ideas:!innovation_idea',
      selection: {
        '@.': '!id',
      },
    },
    release: {
      filter: {
        '=': [
          {
            '@.': '!status',
          },
          'Package & Release',
        ],
      },
      target: 'ent:!innovation_ideas:!innovation_idea',
      selection: {
        '@.': '!id',
      },
    },
    prioritize: {
      filter: {
        '=': [
          {
            '@.': '!status',
          },
          'Score & Prioritize',
        ],
      },
      target: 'ent:!innovation_ideas:!innovation_idea',
      selection: {
        '@.': '!id',
      },
    },
  },
}
